import app from 'flarum/common/app';
import Tooltip from 'flarum/common/components/Tooltip';
import Avatar from 'flarum/common/components/Avatar';
import Link from 'flarum/common/components/Link';
import extractText from 'flarum/common/utils/extractText';
import Widget from 'ext:fof/forum-widgets-core/common/components/Widget';
import onlineUsersState from '../onlineUsersState';
export default class OnlineUsersWidget extends Widget {
  oncreate(vnode) {
    super.oncreate(vnode);

    // Mounting is what tells the state that someone is looking, so it can catch
    // up if the list went stale while they were on another page.
    onlineUsersState.widgetCreated();
  }
  onremove(vnode) {
    super.onremove(vnode);
    onlineUsersState.widgetRemoved();
  }
  className() {
    return 'FoF-OnlineUsersWidget';
  }
  icon() {
    return 'fas fa-user-friends';
  }
  title() {
    return extractText(app.translator.trans('fof-online-users-widget.forum.widget.title'));
  }
  content() {
    // Always the server's answer. onlineUsersState keeps it current by refetching
    // when it goes stale or presence says it has changed, rather than substituting
    // a list of its own — see forum/extendRealtime.ts.
    const users = (app.forum.onlineUsers() || []).filter(u => u !== undefined);
    const total = app.forum.totalOnlineUsers() || 0;
    const more = total - users.length;
    return m("div", {
      className: "FoF-OnlineUsersWidget-users"
    }, m("div", {
      className: "FoF-OnlineUsersWidget-users-message"
    }, users.length === 0 ? app.translator.trans('fof-online-users-widget.forum.widget.empty') : null), m("div", {
      className: "FoF-OnlineUsersWidget-users-list"
    }, users.map(user => m(Link, {
      key: user.id(),
      href: app.route('user', {
        username: user.slug()
      }),
      className: "FoF-OnlineUsersWidget-users-item"
      // The profile this opens is built from the store, which only holds a bare
      // record of the user. See OnlineUsersState.hydrate().
      ,
      onclick: () => onlineUsersState.hydrate(user)
    }, m(Tooltip, {
      text: user.displayName()
    }, m(Avatar, {
      user: user
    })))), more > 0 ? this.moreChip(more) : null));
  }

  /**
   * The "+N" chip. Its text alone ("+3") means nothing to a screen reader, so the
   * label says what it counts.
   */
  moreChip(count) {
    const label = extractText(app.translator.trans('fof-online-users-widget.forum.widget.more', {
      count
    }));
    return m("span", {
      className: "FoF-OnlineUsersWidget-users-item FoF-OnlineUsersWidget-users-item--plus",
      role: "img",
      "aria-label": label,
      title: label
    }, m("span", {
      className: "Avatar",
      "aria-hidden": "true"
    }, `+${count}`));
  }
}
flarum.reg.add('fof-online-users-widget', 'common/components/OnlineUsersWidget', OnlineUsersWidget);